import { Select } from '@applyboard/crystal-ui';
import { useFilterField } from '~/hooks';

export const StatusFilter = () => {
  const { value, setValue } = useFilterField('status', 'PrimaryFilter');

  return (
    <Select
      value={value}
      aria-label="All Intake Statuses"
      placeholder="All Intake Statuses"
      onChange={setValue}
      emphasis="highlighted"
      placeholderVariant="indicator"
      appearance="styled"
    >
      <Select.Option label="Open" value="OPEN" key="Open" />
      <Select.Option label="Closed" value="CLOSED" key="Closed" />
    </Select>
  );
};
